/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-10 15:21:56                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-03-03 14:58:36                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * WorkorderListItem: Display workorder list item
*/

/* Imports */
/***/

/* Components */
import { IconButton } from "@material-tailwind/react";
import { DocumentDuplicateIcon, DocumentTextIcon, PlayCircleIcon, StopCircleIcon, TrashIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import Loading from "../../../../components/loading/Loading";
/***/

import "./WorkorderAdminActions.scss";
import PlayWorkorderModal from "./modals/PlayWorkorderModal";
import DuplicateWorkorderModal from "./modals/DuplicateWorkorderModal";
import DeleteWorkorderModal from "./modals/DeleteWorkorderModal";
import DowloadWorkorderReportModal from "./modals/DowloadWorkorderReportModal";
import SuspendWorkorderModal from "./modals/SuspendWorkorderModal";
/**
* WorkorderListItem: Display workorder list item
* @param workorder - Workorder data
* @param onClick - On click event
* @param isLast - Is last item
*/
export default function WorkorderAdminActions({
  workorder,
  onChange
}: {
  workorder: EasyTech.Workorder,
  onChange: () => void
}) {
  const suspendableWo = ["ACCEPTED", "ON_THE_ROAD", "IN_PROGRESS"];
  const reportReadyWo = ["VALIDATED", "INVOICED", "PAID"];
  const [playLoad, setPlayLoad] = useState<boolean>(false); 
  const [suspendLoad, setSuspendLoad] = useState<boolean>(false); 
  const [dupliLoad, setDupliLoad] = useState<boolean>(false); 
  const [downLoad, setDownLoad] = useState<boolean>(false); 
  const [delLoad, setDelLoad] = useState<boolean>(false); 


  const playWo = () => {
    setPlayLoad(true);
  };

  const suspendWo = () => {
    setSuspendLoad(true);
  };

  const duplicateWo = () => {
    setDupliLoad(true);
  };

  const downloadWoReport = () => {
    setDownLoad(true);
  };

  const deleteWo = () => {
    setDelLoad(true);
  };

  return(
    <div className="admin-wo-actions">
      {workorder.status === "SUSPENDED" && 
        <>
          {(playLoad === false) ?
            <IconButton onClick={playWo} 
              variant="text"
              className={"icon-btn"} 
              size="sm">
              <PlayCircleIcon className="w-[16px]"  />
            </IconButton>
          :
            <Loading size="h-4 w-4" />
          }
        </>
      }

      {suspendableWo.includes(workorder.status) && 
        <>
          {(suspendLoad === false) ?
            <IconButton onClick={suspendWo} 
              variant="text"
              className={"icon-btn"} 
              size="sm">
              <StopCircleIcon className="w-[16px]"  />
            </IconButton>
          :
            <Loading size="h-4 w-4" />
          }
        </>
      }


      {(dupliLoad === false) ?
        <IconButton onClick={duplicateWo} 
          variant="text"
          className={"icon-btn"} 
          size="sm">
          <DocumentDuplicateIcon className="w-[16px]"  />
        </IconButton>
      :
        <Loading size="h-4 w-4" />
      }
      

      {reportReadyWo.includes(workorder.status) && 
        <>
          {(downLoad === false) ?
            <IconButton onClick={downloadWoReport} 
              variant="text"
              className={"icon-btn"} 
              size="sm">
              <DocumentTextIcon className="w-[16px]"  />
            </IconButton>  
          :
            <Loading size="h-4 w-4" />
          }
        </>
      }

      {(delLoad === false) ?
        <IconButton onClick={deleteWo} 
          variant="text"
          className={"icon-btn"} 
          size="sm">
          <TrashIcon className="w-[16px]"  />
        </IconButton>
      :
        <Loading size="h-4 w-4" />  
      }

      {playLoad &&
        <PlayWorkorderModal open={playLoad} workorder={workorder} 
        onUpdate={() => onChange()} onClose={() => setPlayLoad(false)} /> 
      }
      {suspendLoad &&
        <SuspendWorkorderModal open={suspendLoad} workorder={workorder} 
        onUpdate={() => onChange()} onClose={() => setSuspendLoad(false)} /> 
      }
      {dupliLoad &&
        <DuplicateWorkorderModal open={dupliLoad} workorder={workorder} 
        onUpdate={() => onChange()} onClose={() => setDupliLoad(false)} /> 
      }
      {downLoad &&
        <DowloadWorkorderReportModal open={downLoad} workorder={workorder} onClose={() => setDownLoad(false)} /> 
      }
      {delLoad &&
        <DeleteWorkorderModal open={delLoad} workorder={workorder} 
        onDelete={() => onChange()} onClose={() => setDelLoad(false)} /> 
      }
    </div>
  );
}
/***/
